import hashidsUtils from "./hashids-utils";

function getAppId() {
  const appId = window.location.pathname.split("/")[1];
  return appId;
}

function getDecodedAppId() {
  const appId = hashidsUtils.decodeWithoutKey(getAppId());
  return appId;
}

export { getAppId, getDecodedAppId };
